import { Box, Breadcrumbs, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, InputLabel, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import { getSweetAlert, predictionType } from "../../helper";
import { useDispatch, useSelector } from "react-redux";
import { getFormData } from "../../slices/predictInfoSlice";
// import Paper from '@mui/material/Paper';
import axios from "axios";
import { INPLAY_ANALYTICS, INPLAY_TRANSACTION, PREDICTION_ANALYTICS, SALE_DETAILS, SKILLER_ANALYTICS, TRADE_ANALYTICS, TRADE_TRANSACTION } from "../../constant/endpoint";
import { isEmpty } from "lodash";
import moment from "moment";
import { useStyles } from "../../constant/constant";
import Skelton from "../../common/Skelton";

const PredictionManager = () => {
    const dispatch = useDispatch()
    const [getPridictionList, setGetPredictionList] = useState([])
    const [open, setOpen] = React.useState(false);
    const [tradePage, setTradePage] = React.useState(1);
    const [loading, setLoading] = React.useState(false);
    const [transactionDetails, setTransactionDetails] = React.useState("")
    const [saleDetails, setSaleDetails] = React.useState({})
    const classes = useStyles();
    const [details, setDetails] = React.useState({
        matchId: '',
        refundCashAmount: '',
        refundWinAmount: '',
        saleAdminComssionAmount: '',
        saleFee: '',
        slotsOnSale: '',
        soldSlots: '',
        soldSlotsRewards: '',
        totalCash: '',
        totalMatched: '',
        totalSlots: '',
        totalWining: '',
        winReward: '',
        seriesName: '',
        predictionInfo: [],
        matchInfo: [],
        questionEnglish: '',
        entry_fee: '',
        joined_detail: [],
        trade_detail: [],
        pendingAmount: ''
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const predictState = useSelector((state) => state.predictInfo)
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={''} >
            <h4>Prediction</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction Manager
        </Link>
    ];

    useEffect(() => {
        dispatch(getFormData({}))
    }, [])

    const handleChange = (e) => {
        dispatch(getFormData({ name: [e.target.name], value: e.target.value }))
    }
    const isValid = () => {
        let status = true
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/g;
        if (!predictState.phone.match(phoneno)) {
            getSweetAlert('error', 'Phone number can not be greater than 10')
            return status = false
        }
        if (isEmpty(predictState.predictiontype)) {
            getSweetAlert('error', 'Prediction Type cant be Blank')
            return status = false
        }
        if (predictState.startTime && predictState.endTime && (predictState.startTime > predictState.endTime)) {
            getSweetAlert('error', 'Invalid End Time ')
            return status = false
        }
        return status = true
    }

    const callApiforList = async (type, page) => {
        setGetPredictionList([])
        setLoading(true)
        let body = {}
        if (predictState.startTime) {
            let startDate = moment(predictState.startTime);
            startDate =  startDate.startOf('day');
            startDate = startDate.toISOString();
            body["start_time"] = new Date(startDate).toISOString();
        }
        if (predictState.endTime) {
            let endDate = moment(predictState.endTime);
            endDate =  endDate.endOf('day');
            endDate = endDate.toISOString();
            body["end_time"] = new Date(endDate).toISOString();
        }
        if (type === 'TRADING') {
            const getPridictionList = await axios.post(TRADE_ANALYTICS.replace('phonenumber', predictState.phone).replace("pageno", page).replace("matchId", predictState.matchId),
               body
            )
            if (getPridictionList?.data?.status === 'success') {
                setGetPredictionList(getPridictionList?.data?.data)
            }
        }
        if (type === 'OPINION') {
            const getPridictionList = await axios.post(PREDICTION_ANALYTICS.replace('phonenumber', predictState.phone).replace("matchId", predictState.matchId).replace("matchId", predictState.matchId),
            body )
            if (getPridictionList?.data?.status === 'success') {
                setGetPredictionList(getPridictionList?.data?.data?.filter(x => !x.is_subjective))
            }
        }
        if (type === 'OPINION PRO') {
            const getPridictionList = await axios.post(PREDICTION_ANALYTICS.replace('phonenumber', predictState.phone).replace("matchId", predictState.matchId).replace("matchId", predictState.matchId),
            body)
            if (getPridictionList?.data?.status === 'success') {
                setGetPredictionList(getPridictionList?.data?.data?.filter(x => x.is_subjective))
            }
        }
        if (type === 'QUIZ PLAY') {
            const getPridictionList = await axios.post(INPLAY_ANALYTICS.replace('phonenumber', predictState.phone).replace("matchId", predictState.matchId).replace("matchId", predictState.matchId),
            body)
            if (getPridictionList?.data?.status === 'success') {
                setGetPredictionList(getPridictionList?.data?.data)
            }
        }
        if (type === 'SKILLER') {
            const getPridictionList = await axios.post(SKILLER_ANALYTICS.replace('phonenumber', predictState.phone).replace("matchId", predictState.matchId).replace("matchId", predictState.matchId),
            body)
            if (getPridictionList?.data?.status === 'success') {
                setGetPredictionList(getPridictionList?.data?.data)
            }
        }
        setLoading(false)


    }
    const submitHandle = async (event, page) => {
        if (isValid()) {
            callApiforList(predictState.predictiontype, page ? page : tradePage)
        }
    }
    const handlePagination = async (page) => {
        setTradePage(page)
        submitHandle("", page)
    }
    const moreDetails = async (data) => {
      let request =  {
            "user_id": data.userId,
            "prediction_id": data?.predictionInfo[0]._id,
            "time": predictState.predictiontype === 'TRADING' ? data.created_at : data.createdAt
        }
        if (predictState.predictiontype === 'TRADING') {
            getSaleDetails(data)
            setTransactionDetails("")
            setLoading(true)
            const transactionData = await axios.post(TRADE_TRANSACTION,
                request
            );
            setTransactionDetails(parseTransactionDetailsTrading(transactionData.data.data))

        }
        else if (predictState.predictiontype === 'QUIZ PLAY') {
            setTransactionDetails("")
            setLoading(true)
            const transactionData = await axios.post(INPLAY_TRANSACTION,
                request
            );
            setTransactionDetails((transactionData.data.data))
            
        }
        setLoading(false)
        let afterAdminCommission = (100 - data?.predictionInfo[0]?.admin_commission) ? (100 - data?.predictionInfo[0]?.admin_commission) / 100 : 0;
        let distribute_winning = false
        handleClickOpen()
        if (predictState.predictiontype === "QUIZ PLAY")
        {
            distribute_winning = data?.predictionInfo[0]?.win_distribute
        }
        else {
            distribute_winning = data?.predictionInfo[0]?.distribute_winning
        }
        setDetails({
            questionEnglish: data.questionEnglish,
            matchId: data.matchId,
            entryFee: data.entryFee ? data.entryFee : '',
            refundCashAmount: data.refundCashAmount,
            refundWinAmount: data.refundWinAmount,
            saleAdminComssionAmount: data.saleAdminComssionAmount,
            saleFee: data.saleFee,
            slotsOnSale: data.slotsOnSale,
            soldSlots: data.soldSlots,
            soldSlotsRewards: data.soldSlotsRewards,
            totalCash: data.totalCash,
            totalMatched: data.totalMatched,
            totalSlots: data.totalSlots,
            totalWining: data.totalWining,
            winReward: data.winReward,
            predictionInfo: data.predictionInfo,
            subj_opt1: data.subj_opt1,
            joined_detail: data?.joined_detail ? data?.joined_detail : '',
            matchInfo: data.matchInfo,
            question_english: data?.question_english ? data?.question_english : '',
            total_slot: data?.total_slot ? data?.total_slot : '',
            total_wining: data?.total_wining ? data?.total_wining : '',
            win_reward: data?.win_reward ? data?.win_reward : '',
            total_cash: data?.total_cash ? data?.total_cash : '',
            is_pred_cancel: data?.is_pred_cancel ? data?.is_pred_cancel : 0,
            trade_detail: data?._id ? data?._id : [],
            distribute_winning: distribute_winning ? "true" : "false",
            pendingAmount: data?.pendingAmount ? (data.pendingAmount) * afterAdminCommission : 0,
            soldProfit: getSoldProfit(data, afterAdminCommission).profit,
            soldLoss: getSoldProfit(data, afterAdminCommission).loss,
            proPlayRate: data?.expectedWinningAmount || 0,
            rate: data?.rate || 0,
            option_id: data?._id?.option_id == 1 ? "OVER" : "UNDER",
            joiningScoreOverUnder: data?.runs,
            inCash: data?.inCash,
            inWinning: data?.inWinning,
            
            
        })
    }
    const getSaleDetails = async (data) => {
            setSaleDetails("")
              const saleData = await axios.get(SALE_DETAILS.replace(":recordId", data?._id?._id)
              );
            setSaleDetails(saleData?.data?.data || "")
          }
    const parseTransactionDetailsTrading = (data) => {
        let trans = [];
        data.map((currentData) => {
            if(currentData.type == "join_slots")
            {
                trans.push({
                    time: "Before Join",                 
                    debitAmount: (currentData?.wallet_details?.debited_cash || 0) + (currentData?.wallet_details?.debited_winning || 0) + (currentData?.wallet_details?.debited_promotion || 0),
                    cashBalance: currentData?.wallet_details?.current_cash_balance || 0,
                    winningBalance: currentData?.wallet_details?.current_winning_balance || 0,
                    promotionBalance: currentData?.wallet_details?.current_promotion_balance || 0,
                    totalRefund:"NA"
                }) 
                trans.push({                    
                        time: "Refund", 
                        debitAmount: "NA",
                        totalRefund: (currentData?.wallet_details?.refund_cash || 0 )+ (currentData?.wallet_details?.refund_winning || 0) + (currentData?.wallet_details?.refund_promotion || 0),    
                })
                trans.push({
                    time: "After Join", 
                    debitAmount: "NA",
                    cashBalance: currentData?.wallet_details?.updated_cash_balance || 0,
                    winningBalance: currentData?.wallet_details?.updated_winning_balance || 0,
                    promotionBalance: currentData?.wallet_details?.updated_promotion_balance || 0,
                    totalRefund:"NA"
                })
            }
          

        })
        return trans;

    }

    const getSoldProfit = (data, afterAdminCommission) => {
        const { soldSlots, pendingAmount, soldSlotsRewards, _id } = data ?? {};
        const slotFee = _id?.slot_fee ?? 0;
        let netPendingAmount = (pendingAmount || 0) * afterAdminCommission;
        const returnAmount = soldSlots > 0 ? (netPendingAmount + soldSlotsRewards) - (slotFee * soldSlots) : 0;   
        
        return {
            profit: Math.max(returnAmount, 0),
            loss: Math.min(returnAmount, 0)
        };
    };
    
    return (
        <>
            {loading ? <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 9999, // Ensure it stays above other elements
                    paddingTop: '20%', // Space from top of the page
                }}
            >
                <CircularProgress />
            </Box> : ""}
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <div>
                        <Container maxWidth="xl">
                            <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                                <Grid item xs={4}>
                                    <InputLabel id="demo-simple-select-label">Mobile No</InputLabel>
                                    <TextField type="number" id="outlined-basic" label="000-000-000-0" variant="outlined" style={{ width: "100%" }} placeholder="Enter Mobile No" name={'phone'} onChange={handleChange}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel id="demo-simple-select-label">Prediction Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        // value={age}
                                        label="Enter Prediction Type"
                                        style={{ width: "100%" }}
                                        name={'predictiontype'}
                                        placeholder="Enter Prediction Type"
                                        onChange={handleChange}
                                    >
                                        {predictionType.map((data) =>
                                            <MenuItem value={data}>{data}</MenuItem>
                                        )}
                                    </Select>
                                </Grid>
                                <Grid item xs={2}>
                                    <InputLabel id="demo-simple-select-label">Match Id</InputLabel>
                                    <TextField type="number" id="outlined-basic" label="Enter Match Id" variant="outlined" style={{ width: "100%" }} placeholder="Enter Match Id" name={'matchId'} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={4} style={{ margin: "auto" }}>
                                    <Button variant={'contained'} color={'primary'} onClick={submitHandle}>Submit</Button>
                                </Grid>
                                <Grid item xs={4}>
                                    <InputLabel id="demo-simple-select-label">From</InputLabel>
                                    <TextField type="date" id="outlined-basic"  variant="outlined" style={{ width: "100%" }} placeholder="From" name={'startTime'} onChange={handleChange} />
                                </Grid>
                                <Grid item xs={4}>
                                    <InputLabel id="demo-simple-select-label">To</InputLabel>
                                    <TextField type="date" id="outlined-basic"  variant="outlined" style={{ width: "100%" }} placeholder="To" name={'endTime'} onChange={handleChange} />
                                </Grid>
                            </Grid>
                        </Container>
                        {

                            getPridictionList.length > 0 ?
                                <>
                                <Container maxWidth="xl">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TableContainer >
                                                <Table className={classes.table}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left">S.No</TableCell>
                                                            <TableCell align="left">Match Name</TableCell>
                                                            <TableCell align="left">Question</TableCell>
                                                            <TableCell align="center">Total Deductions</TableCell>
                                                            <TableCell align="center">Win Reward</TableCell>
                                                            <TableCell align="center">Win Distributed</TableCell>
                                                            <TableCell align="center">Joined Time</TableCell>
                                                            <TableCell align="center">Details</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {getPridictionList?.map((row,index) => (
                                                            <TableRow
                                                                key={row.name}
                                                                style={{ marginTop: "10px" }}
                                                            >
                                                                {/* <TableCell align="left">{row.}</TableCell> */}
                                                                <TableCell align="left">{ index+1}</TableCell>
                                                                <TableCell align="left">{row?.matchInfo[0]?.visitorteam} vs {row?.matchInfo[0]?.localteam}</TableCell>
                                                                <TableCell align="left">{row?.questionEnglish}{row?.question_english}</TableCell>
                                                                <TableCell align="center">


                                                                    {
                                                                        predictState.predictiontype === 'TRADING' && row?.totalWining + row?.totalCash
                                                                    }

                                                                    {
                                                                        predictState.predictiontype === 'OPINION' && row?.total_wining + row?.total_cash
                                                                    }

                                                                    {
                                                                        predictState.predictiontype === 'OPINION PRO' && row?.total_wining + row?.total_cash
                                                                    }

                                                                    {
                                                                        predictState.predictiontype === 'QUIZ PLAY' && row?.totalWining + row?.totalCash
                                                                    }
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {
                                                                        predictState.predictiontype === 'TRADING' &&
                                                                        (row?.winReward ? `Rs. ` + (row?.winReward + row?.refundCashAmount + row?.refundWinAmount) : `Rs. 0`)
                                                                    }

                                                                    {
                                                                        predictState.predictiontype === 'OPINION' &&
                                                                        (row?.win_reward ? `Rs. ` + row?.win_reward : `Rs. 0`)
                                                                    }

                                                                    {
                                                                        predictState.predictiontype === 'OPINION PRO' &&
                                                                        (row?.win_reward ? `Rs. ` + row?.win_reward : `Rs. 0`)
                                                                    }

                                                                    {
                                                                        predictState.predictiontype === 'QUIZ PLAY' &&
                                                                        (row?.winReward ? `Rs. ` + row?.winReward : `Rs. 0`)
                                                                    }

                                                                </TableCell>
                                                                
                                                                {
                                                                    predictState.predictiontype === 'TRADING' &&
                                                                    <TableCell align="center">{row?.predictionInfo[0]?.distribute_winning?.toString()}</TableCell>
                                                                }
                                                                 {
                                                                    predictState.predictiontype === 'QUIZ PLAY' &&
                                                                    <TableCell align="center">{row?.predictionInfo[0]?.win_distribute?.toString()}</TableCell>
                                                                }
                                                                
                                                                <TableCell align="center">
                                                                    {row?.createdAt  ? moment(row?.createdAt).format("DD-MMM-YYYY hh:mm a") : row?.created_at  ?   moment(row?.created_at).format("DD-MMM-YYYY hh:mm a") : ""}

                                                                </TableCell>
                                                                <TableCell>
                                                                    <Button variant={'contained'} size={'small'} color={'info'} onClick={() => moreDetails(row)}>Details</Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                    </Container>

                                    <Container spacing={2}  style={{paddingBottom:"20px"}}>
                        {
                                            getPridictionList.length > 0 &&
                                            <div style={{display:"flex", justifyContent:"end"}}>
                                                    {
                                                        tradePage > 1 ? <span style={{color:"#0288d1", cursor:"pointer", fontWeight:"bolder", fontSize:"20px"}} onClick={()=> handlePagination(tradePage -1)}> {"<"} </span> : ""
                                                    } 
                                                    <span  style={{fontSize:"20px", padding:"0px 4px"}}>{tradePage}</span>
                                                    {
                                                         getPridictionList.length == 50 ?
                                                         <span style={{ color:"#0288d1", cursor:"pointer",  fontWeight:"bolder", fontSize:"20px"}} onClick={() => handlePagination(tradePage + 1)}> {">"}
                                                            </span>
                                                            : ""
                                                    }
                                            </div>
                        }
                                 </Container>
                      
                                </> :
                                <>
                                    {
                                        loading ? <></> :
                                <Table>
                                    <TableRow>
                                        <h3 style={{ textAlign: "center" }}>No Data Found</h3>
                                    </TableRow>
                                </Table>
                                    }
                                    </>
                        }
                    </div>
                </div>
                <>
                    {
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Pred Id :- {details.predictionInfo[0]?._id}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Container maxWidth="xl">
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TableContainer >
                                            <Table size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableRow>
                                                            <TableCell align="left">Match Name</TableCell>
                                                            <TableCell align="left">{details?.matchInfo[0]?.localteam} Vs {details?.matchInfo[0]?.visitorteam}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left">Series Name</TableCell>
                                                            <TableCell align="left">{details?.matchInfo[0]?.series_name}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left">Questions</TableCell>
                                                            <TableCell align="left">{details?.questionEnglish}{details?.question_english}</TableCell>
                                                        </TableRow>
                                                
                                                                <TableRow>
                                                                    <TableCell align="left">Winning Distributed</TableCell>
                                                            <TableCell align="left">{details?.distribute_winning}</TableCell>
                                                                </TableRow>
                                              

                                                        {
                                                            predictState.predictiontype === 'OPINION PRO' ?
                                                                <TableRow>
                                                                    <TableCell align="left">Correct Answer</TableCell>
                                                                    <TableCell align="left">{details?.predictionInfo[0]?.inputAnswerNumber}</TableCell>
                                                                </TableRow>
                                                                :
                                                                <>
                                                                    {predictState.predictiontype === 'SKILLER'  ?
                                                                        <TableRow>
                                                                            <TableCell align="left">Correct Answer</TableCell>
                                                                            <TableCell align="left">{details?.predictionInfo[0]?.score}</TableCell>
                                                                        </TableRow> :
                                                                        <TableRow>
                                                                            <TableCell align="left">Correct Answer</TableCell>
                                                                            <TableCell align="left">{details?.predictionInfo[0]?.option.find(x => x.isCorrect)?.option}{details?.predictionInfo[0]?.correct_answer}</TableCell>
                                                                        </TableRow>
                                                                    }
                                                                    </>
                                                        }
                                                        {
                                                            predictState.predictiontype === 'SKILLER' &&
                                                            <TableRow>
                                                                <TableCell align="left">User Input Rate</TableCell>
                                                                <TableCell align="left">{details.rate}</TableCell>
                                                            </TableRow>
                                                        }
                                                        <TableRow>
                                                            <TableCell align="left">User Answer</TableCell>
                                                            {
                                                                predictState.predictiontype === 'OPINION PRO' &&
                                                                <TableCell align="left">{details?.subj_opt1}</TableCell>
                                                            }
                                                            {
                                                                predictState.predictiontype === 'OPINION' &&
                                                                <TableCell align="left">{details?.joined_detail[0]?.opt}</TableCell>
                                                            }
                                                            {
                                                                predictState.predictiontype === 'TRADING' &&
                                                                <TableCell align="left">{details?.predictionInfo[0]?.option?.filter(x=>x.id === details?.trade_detail?.option_id)[0]?.option}</TableCell>
                                                            }
                                                            {
                                                                predictState.predictiontype === 'QUIZ PLAY' && details?.predictionInfo[0]?.is_over_under == false &&
                                                                <TableCell align="left">{details?.predictionInfo[0]?.option?.filter(x=>x.id === details?.trade_detail?.option_id)[0]?.option}</TableCell>
                                                            }
                                                             {
                                                                predictState.predictiontype === 'QUIZ PLAY' && details?.predictionInfo[0]?.is_over_under == true &&
                                                                <TableCell align="left">{details?.option_id}</TableCell>
                                                            }
                                                            {

                                                                predictState.predictiontype === 'SKILLER' &&
                                                                <TableCell align="left">{details?.predictionInfo[0]?.option?.filter(x=>x.id === details?.trade_detail?.option_id)[0]?.option}</TableCell>
                                                            }
                                                                </TableRow>
                                                         {
                                                            predictState.predictiontype === 'QUIZ PLAY' && details?.predictionInfo[0]?.is_over_under == true &&
                                                            <TableRow>
                                                                <TableCell align="left">Joining Score</TableCell>
                                                                <TableCell align="left">{details?.joiningScoreOverUnder}</TableCell>
                                                            </TableRow>
                                                        }
                                                        <TableRow>
                                                            <TableCell align="left">Slot Amount</TableCell>
                                                            {
                                                                predictState.predictiontype === 'TRADING' &&
                                                                <TableCell align="left">{details?.trade_detail?.slot_fee}</TableCell>
                                                            }
                                                            {
                                                                predictState.predictiontype === 'OPINION' &&
                                                                <TableCell align="left">{details?.predictionInfo[0]?.entry_fee}</TableCell>
                                                            }
                                                            {
                                                                predictState.predictiontype === 'OPINION PRO' &&
                                                                <TableCell align="left">{details?.predictionInfo[0]?.entry_fee}</TableCell>
                                                            }
                                                            {
                                                                predictState.predictiontype === 'QUIZ PLAY' &&
                                                                <TableCell align="left">{details?.entryFee}</TableCell>
                                                            }
                                                             {
                                                                predictState.predictiontype === 'SKILLER' &&
                                                                <TableCell align="left">{details?.trade_detail?.slot_fee}</TableCell>
                                                            }
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left">Total Slots</TableCell>
                                                            <TableCell align="left">{details?.totalSlots}{details?.total_slot}</TableCell>
                                                        </TableRow>

                                                        {
                                                            predictState.predictiontype === 'TRADING' ||  predictState.predictiontype === 'SKILLER' ?
                                                                <TableRow>
                                                                    <TableCell align="left">Refund Cash Amount</TableCell>
                                                                    <TableCell align="left">{details.refundCashAmount}</TableCell>
                                                                </TableRow> :
                                                                <TableRow>
                                                                    <TableCell align="left">Refund Amount</TableCell>
                                                                    <TableCell align="left">{details?.is_pred_cancel === 1 ? details?.total_cash + details?.total_wining : 0}</TableCell>
                                                                </TableRow>
                                                        }
                                                        {
                                                            (predictState.predictiontype === 'TRADING' || predictState.predictiontype === 'SKILLER') &&
                                                            <TableRow>
                                                                <TableCell align="left">Refund Win Amount</TableCell>
                                                                <TableCell align="left">{details.refundWinAmount}</TableCell>
                                                            </TableRow>
                                                        }
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Sale Admin Commission Amount</TableCell>
                                                                <TableCell align="left">{details.saleAdminComssionAmount}</TableCell>
                                                            </TableRow>
                                                        }
                                                        <TableRow>
                                                            <TableCell align="left">Debited from Winning</TableCell>
                                                            <TableCell align="left">{details?.totalWining ? details?.totalWining : details?.total_wining ? details?.total_wining : 0}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left">Debited From Deposit</TableCell>
                                                            <TableCell align="left">{details?.totalCash ? details?.totalCash : details?.total_cash ? details?.total_cash : 0}</TableCell>
                                                        </TableRow>
                                                        
                                                        <TableRow>
                                                            <TableCell align="left">Win Reward</TableCell>
                                                            <TableCell align="left">{details?.winReward ? details?.winReward : (details?.win_reward ? details?.win_reward : 0)}</TableCell>
                                                            {/* <TableCell align="left">{get(details, 'winReward', 0)}</TableCell> */}
                                                                </TableRow>

                                                                {
                                                                    <>
                                                                        <TableRow>
                                                                            <TableCell align="left">In Cash Reward</TableCell>
                                                                            <TableCell align="left">{details?.inCash}</TableCell>
                                                                        </TableRow>
                                                                        <TableRow>
                                                                            <TableCell align="left">In Win Reward</TableCell>
                                                                            <TableCell align="left">{details?.inWinning}</TableCell>
                                                                        </TableRow>
                                                                    </>
                                                                }
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Total Matched</TableCell>
                                                                <TableCell align="left">{details.totalMatched}</TableCell>
                                                            </TableRow>
                                                        }
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Total UnMatched</TableCell>
                                                                <TableCell align="left">{details.totalSlots - details.totalMatched}</TableCell>
                                                            </TableRow>
                                                        }


                                                        {/* {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Sale Fee</TableCell>
                                                                <TableCell align="left">{details.saleFee}</TableCell>
                                                            </TableRow>
                                                        } */}
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Slots On Sale</TableCell>
                                                                <TableCell align="left">{details.slotsOnSale}</TableCell>
                                                            </TableRow>
                                                        }
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Sold Slots</TableCell>
                                                                <TableCell align="left">{details.soldSlots}</TableCell>
                                                            </TableRow>
                                                        }
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Sold Slots Rewards</TableCell>
                                                                <TableCell align="left">{details.soldSlotsRewards}</TableCell>
                                                            </TableRow>
                                                        }
                                                        {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Pending Amount</TableCell>
                                                                <TableCell align="left">{details.pendingAmount}</TableCell>
                                                            </TableRow>
                                                        }
                                                          {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Sold Profit</TableCell>
                                                                <TableCell align="left">{details?.soldProfit}</TableCell>
                                                            </TableRow>
                                                        }
                                                         {
                                                            predictState.predictiontype === 'TRADING' &&
                                                            <TableRow>
                                                                <TableCell align="left">Sold Loss</TableCell>
                                                                <TableCell align="left">{details?.soldLoss}</TableCell>
                                                            </TableRow>
                                                        }

                                                        {
                                                            predictState.predictiontype === 'QUIZ PLAY' &&
                                                            <TableRow>
                                                                <TableCell align="left">Rate</TableCell>
                                                                <TableCell align="left">{details?.proPlayRate}</TableCell>
                                                            </TableRow>
                                                                }
                                                               
                                                        
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow
                                                        // key={row.name}
                                                    >
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                       
                                        {predictState.predictiontype === 'TRADING' && saleDetails && Object.keys(saleDetails).length > 0 &&
                                            <>
                                            <h1>Sale Trade Data</h1>
                                            <Table>
                                       
                                       <TableHead>
                                           <TableRow>
                                               <TableCell>Sold slot Key</TableCell>
                                               <TableCell>Slot Count</TableCell>
                                       
                                           </TableRow>
                                       </TableHead>
                                       <TableBody>
                                           {saleDetails && Object.keys(saleDetails) && Object.keys(saleDetails).map((data) => (
                                               <TableRow>
                                                   <TableCell>{data}</TableCell>
                                                   <TableCell>{saleDetails[data]} </TableCell>
                                                  
                                               </TableRow>
                                           ))}
                                       </TableBody>
                                   </Table>
                                            </>
                                         
                                        }



                                        <h1>Transaction Data</h1>
                                        {predictState.predictiontype === 'TRADING' &&
                                            <Table>
                                       
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Time</TableCell>
                                                        <TableCell>Cash Balance</TableCell>
                                                        <TableCell>Winning Balance</TableCell>
                                                        <TableCell>Promotion Balance</TableCell>
                                                        <TableCell>Debited Amount</TableCell>
                                                        <TableCell>Refund</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {transactionDetails && transactionDetails.length && transactionDetails.map((data) => (
                                                        <TableRow>
                                                            <TableCell>{data?.time}</TableCell>
                                                            <TableCell> {data?.cashBalance}</TableCell>
                                                            <TableCell>{data?.winningBalance}</TableCell>
                                                            <TableCell>{data?.promotionBalance}</TableCell>
                                                            <TableCell>{data?.debitAmount }</TableCell>
                                                            <TableCell>{data?.totalRefund }</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        }
                                        {predictState.predictiontype === 'QUIZ PLAY' && 
                                            <Table>
                                                <TableHead>
                                                    <TableCell>Cash Balance</TableCell>
                                                    <TableCell>Winning Balance</TableCell>
                                                    <TableCell>Debited Amount</TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    <TableCell>{ transactionDetails?.cash_balance}</TableCell>
                                                    <TableCell>{ transactionDetails?.winning_balance}</TableCell>
                                                    <TableCell>{ transactionDetails?.debited_amount}</TableCell>
                                                </TableBody>
                                        </Table>
                                        }
                                    </Grid>
                                </Grid>
                            </Container>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} autoFocus color={'error'} variant={'contained'}>
                            Close
                        </Button>
                    </DialogActions>
                    </Dialog>
                     } 
                    </>
            </div>
        </>
    )
}
export default PredictionManager